(ns manage.ad-variant.creation.link.queries
  (:require [common.queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn available-third-party-projects
  [url-context project-id workspace-id tenant-id token enabled]
  #js {:queryKey #js ["available-third-party-projects"]
       :enabled (boolean enabled)
       :queryFn (fn [_ctx]
                  (qhttp/get
                   (qhttp/render :api/adset-ps-campaigns url-context {:wpp-os-project-id project-id})
                   {:headers {:Authorization (str "Bearer " token)
                              :X-agency-id (:agency-id url-context)
                              :X-project-id project-id
                              :X-workspace-id workspace-id
                              :X-tenant-id tenant-id}}))})

(defn adset-project-ids-mutation [{:keys [adset-id]}]
  #js {:mutationKey #js ["adset-project-ids-mutation" adset-id]
       :mutationFn (fn [campaign-ids]
                     (qhttp/post (qhttp/render :api/adset-ps-campaign-id {:adset-id adset-id})
                                 {:body {:PSCampaignIDs campaign-ids
                                         :operation "replace"}}))
       :onMutate (fn []
                   (rf/dispatch [:loader/open]))
       :onSettled (fn []
                    (rf/dispatch [:loader/close]))
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["adset" adset-id]})
                    (invalidate-queries {:queryKey ["available-third-party-projects"]})
                    (rf/dispatch [:resource.adset/patch {:autoApproveAdVariants true}])
                    (rf/dispatch [:ocp/close {:id :ad-variants-link-ocp}])
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "adset"
                                   :type :success
                                   :message "Successfully linked adset"}]))
       :onError (fn []
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "adset"
                                 :type :success
                                 :message "Failed to link adset"}]))})